import { render } from "./MainLoadingStyle.vue?vue&type=template&id=5c8b94e8&scoped=true"
import script from "./MainLoadingStyle.vue?vue&type=script&lang=js"
export * from "./MainLoadingStyle.vue?vue&type=script&lang=js"

import "./MainLoadingStyle.vue?vue&type=style&index=0&id=5c8b94e8&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8b94e8"]])

export default __exports__